import utils from '@/mixins/utils'
import { formatarCadastrosComDoses } from './functions.js'

export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterIdade,
  selectedFilterVacinas
) {
  let cadastrosFiltrados = formatarCadastrosComDoses(cadastros)

  if (selectedFilterIdade != null) {
    cadastrosFiltrados = filtrarPorIdade(
      cadastrosFiltrados,
      selectedFilterIdade
    )
  }

  if (selectedFilterVacinas != null) {
    cadastrosFiltrados = filtrarPorVacina(
      cadastrosFiltrados,
      exibirVermelhos,
      exibirVerdes,
      selectedFilterVacinas
    )
  }

  if (exibirVermelhos === true) {
    cadastrosFiltrados = buscarVermelhos(cadastrosFiltrados)
  }

  if (exibirVerdes === true) {
    cadastrosFiltrados = buscarVerdes(cadastrosFiltrados)
  }

  return cadastrosFiltrados
}

function buscarVermelhos(cadastros) {
  const camposCores = [
    'coresCovid19',
    'coresPenta',
    'coresVip',
    'coresDtp',
    'coresBcg',
    'coresHepatiteB',
    'coresPneumococica',
    'coresRotaVirus',
    'coresMeningococicaC',
    'coresFebreAmarela',
    'coresHepatiteA',
    'coresTripliceViral',
    'coresTetraViral',
    'coresVaricela',
    'coresHpv',
    'coresAcwy',
    'coresDuplaAdulto',
  ]

  return cadastros.filter((item) =>
    camposCores.some(
      (campo) =>
        Array.isArray(item[campo]) &&
        item[campo].some((dose) => dose.cor === 'red')
    )
  )
}

function buscarVerdes(cadastros) {
  const camposCores = [
    'coresCovid19',
    'coresPenta',
    'coresVip',
    'coresDtp',
    'coresBcg',
    'coresHepatiteB',
    'coresPneumococica',
    'coresRotaVirus',
    'coresMeningococicaC',
    'coresFebreAmarela',
    'coresHepatiteA',
    'coresTripliceViral',
    'coresTetraViral',
    'coresVaricela',
    'coresHpv',
    'coresAcwy',
    'coresDuplaAdulto',
  ]

  const coresPermitidas = new Set(['green', 'white'])

  return cadastros.filter((item) =>
    camposCores.every((campo) => {
      const arr = item[campo]
      return (
        Array.isArray(arr) && arr.every((el) => coresPermitidas.has(el.cor))
      )
    })
  )
}

function filtrarPorIdade(cadastros, filter) {
  let filtrado = cadastros.filter((item) => {
    if (filter === null) {
      return item
    }
    if (filter.value === '0 - 24 meses') {
      return Number(item.idade_meses) >= 0 && Number(item.idade_meses) <= 24
    } else if (filter.value === '2 - 4 anos') {
      return Number(item.idade_anos) >= 2 && Number(item.idade_anos) <= 4
    } else if (filter.value === '5 - 10 anos') {
      return Number(item.idade_anos) >= 5 && Number(item.idade_anos) <= 10
    } else if (filter.value === '11 - 14 anos') {
      return Number(item.idade_anos) >= 11 && Number(item.idade_anos) <= 14
    } else {
      return item
    }
  })
  return filtrado
}

function filtrarPorVacina(cadastros, exibirVermelhos, exibirVerdes, filter) {
  let vacina = filter.value

  if (vacina == null) return cadastros

  if (exibirVermelhos === true) {
    return cadastros.filter((el) => {
      return el[vacina].some((dose) => dose.cor === 'red')
    })
  }

  if (exibirVerdes === true) {
    return cadastros.filter((el) => {
      return el[vacina].every((dose) => dose.cor === 'green')
    })
  }
}
